(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('DashboardManagementDetailController', DashboardManagementDetailController);

    DashboardManagementDetailController.$inject = ['$scope', '$rootScope', 'entity'];

    function DashboardManagementDetailController($scope, $rootScope, entity) {
        var vm = this;
        vm.dashboard = entity;

        var unsubscribe = $rootScope.$on('jotApp:dashboardUpdate', function(event, result) {
            vm.dashboard = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
